import { api } from './apiClient';

export interface SpecListParams {
  page: number;
  size: number;
  search?: string;
  categoryId?: number;
}

export const specService = {
  // 获取规格分类列表
  getCategoryList: async (params: SpecListParams) => {
    return api.get('/admin/spec/category/list', { params });
  },

  // 获取规格选项列表
  getOptionList: async (params: SpecListParams) => {
    return api.get('/admin/spec/option/list', { params });
  },

  // 获取规格详情
  getSpecDetail: async (id: number) => {
    return api.get('/admin/spec/detail', { params: { id } });
  },

  // 新增规格（统一接口）
  addSpec: async (data: any) => {
    return api.post('/admin/spec/save', data);
  },

  // 新增顶级规格（pId固定为0）
  addTopLevelSpec: async (data: any) => {
    const topLevelData = {
      ...data,
      pId: 0
    };
    return api.post('/admin/spec/save', topLevelData);
  },

  // 新增子级规格
  addSubSpec: async (parentId: number, data: any) => {
    const subData = {
      ...data,
      pId: parentId
    };
    return api.post('/admin/spec/save', subData);
  },

  // 更新规格
  updateSpec: async (id: number, data: any) => {
    return api.post('/admin/spec/update', { ...data, id });
  },

  // 删除规格
  deleteSpec: async (id: number) => {
    return api.post('/admin/spec/delete', null, { 
      params: { 
        id: id.toString()
      } 
    });
  },

  // 获取规格分类树形结构
  getSpecTree: async () => {
    return api.get('/admin/spec/tree', { params: {} });
  },

  // 查询商品关联的规格
  getProductSpecs: async (productId: string) => {
    return api.get(`/admin/spec/product/${productId}`);
  },

  // 更新商品关联的规格
  updateProductSpecs: async (productId: string, specIds: number[]) => {
    return api.post(`/admin/spec/product/${productId}`, { specIds });
  },

  // 初始化测试数据
  initTestData: async () => {
    return api.post('/admin/spec/init-test-data');
  },
};
